import React from 'react';
import { Link } from 'react-router-dom';
export function TopBar() {
  return <div className="w-full bg-[#1a0647] py-1.5 px-6 md:px-12" data-id="element-388">
      <div className="max-w-7xl mx-auto flex items-center justify-end" data-id="element-389">
        <span className="text-white text-xs font-normal" data-id="element-390">
          Have you or a loved one been hacked? See our{' '}
          <Link to="/crisis-help" className="text-[#00f4f8] hover:underline" data-id="element-391">
            Crisis Response Guide
          </Link>
        </span>
      </div>
    </div>;
}